export default __webpack_public_path__ + "static/media/gam_1.6bd96b00.webp";